<template>
  <a-card size="small" type="inner">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">

        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>
          <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" @click="handleDownload" :style="{ display: expand ? 'inline-block' : 'none'}"/>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>
    <a-skeleton :loading="loading" active>
      <h3 class="text-center">Summary for
        <strong v-if="filters.date.length > 0">
          {{ moment(filters.date[0], 'YYYY-MM-DD').format('DD MMMM YYYY') }} - {{ moment(filters.date[1], 'YYYY-MM-DD').format('DD MMMM YYYY') }}
        </strong>
        <strong v-else>{{ moment().format("MMMM YYYY") }}</strong>
      </h3>
      <a-divider dashed/>

      <a-page-header>
        <a-row type="flex" justify="space-around">
          <a-statistic title="Total Count" :value="loading ? 0 : total.count"/>
          <a-statistic title="Total Bills" :value="loading ? 0 : total.bills"/>
          <a-statistic title="Total Biller Price" :value="loading ? 0 : total.billerPrice"/>
          <a-statistic title="Total Admin Fee" :value="loading ? 0 : total.adminFee"/>
          <a-statistic title="Total Share Fee" :value="loading ? 0 : total.shareFee"/>
          <a-statistic title="Total Profit" :value="loading ? 0 : total.profit"/>
        </a-row>
      </a-page-header>

      <a-table :columns="columns"
               :dataSource="items.data"
               rowKey="biller_name"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">

        <h4 slot="name" slot-scope="name">{{ name }}</h4>

        <h4 class="text-center" slot="count" slot-scope="record">{{ number(record.count) }}</h4>
        <h4 class="text-center" slot="bills" slot-scope="record">{{ number(record.total_bills) }}</h4>

        <h4 slot="billerPrice" slot-scope="record"><currency :amount="record.biller_price" /></h4>
        <h4 slot="adminFee" slot-scope="record"><currency :amount="record.biller_admin_fee" /></h4>
        <h4 slot="shareFee" slot-scope="record"><currency :amount="record.biller_share_fee" /></h4>
        <h4 slot="profit" slot-scope="record"><currency :amount="record.profit" /></h4>
      </a-table>
    </a-skeleton>
  </a-card>
</template>

<script>
const columns = [
  {
    dataIndex: 'biller_name',
    key: 'biller_name',
    title: 'Biller',
    scopedSlots: {customRender: 'name'}
  }, {
    key: 'count',
    title: 'Count',
    align: 'center',
    width: 100,
    scopedSlots: {customRender: 'count'}
  }, {
    key: 'bills',
    title: 'Bills',
    align: 'center',
    width: 100,
    scopedSlots: {customRender: 'bills'}
  }, {
    key: 'biller_price',
    title: 'Biller Price',
    scopedSlots: {customRender: 'billerPrice'}
  }, {
    key: 'admin_fee',
    title: 'Admin Fee',
    scopedSlots: {customRender: 'adminFee'}
  }, {
    key: 'share_fee',
    title: 'Share Fee',
    scopedSlots: {customRender: 'shareFee'}
  }, {
    key: 'profit',
    title: 'Profit',
    scopedSlots: {customRender: 'profit'}
  }
];

export default {
  name: "biller-transaction-summary",
  computed: {
    uri() {
      return this.routeUri('hyperion.transaction.summary.biller')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('hyperion.transaction.summary.export.biller') + '?' + this.$qs.stringify(params)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      filters: {
        page: 1,
        per_page: 10,
        date: [],
      },
      total: {
        count: 0,
        bills: 0,
        billerPrice: 0,
        adminFee: 0,
        shareFee: 0,
        profit: 0,
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        date: []
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleDownload() {
      window.open(this.exportUri, '_blank')
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => {
          this.items = response.data

          Object.keys(this.total).forEach((i) => this.total[i] = 0)

          this.items.data.forEach((item) => {
            this.total.count += parseInt(item.count)
            this.total.bills += parseInt(item.total_bills)
            this.total.billerPrice += parseInt(item.biller_price)
            this.total.adminFee += parseInt(item.biller_admin_fee)
            this.total.shareFee += parseInt(item.biller_share_fee)
            this.total.profit += parseInt(item.profit)
          })
        })
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>

</style>
